














































































































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { getValidationErrorText } from '@/utils/validate';
import { mdiTrashCanOutline, mdiGreasePencil } from '@mdi/js';
import { converterFileSize, getSubDescription } from '@/utils/common';
import { getFileLink } from '@/api/filestorage';
import PreLoader from '@/components/base/PreLoader.vue';
import {UploadDocumentTypes} from "@/utils/uploadDocumentTypes";

@Component({
  components: { PreLoader },
  data: () => ({
    getFileLink,
    getValidationErrorText,
    mdiTrashCanOutline,
    mdiGreasePencil,
    converterFileSize,
    getSubDescription,
  }),
})
export default class DocumentTableViewer extends Vue {
  @Prop({ default: false }) fullViewMode!: boolean;
  @Prop() editable!: boolean;
  @Prop() removable!: boolean;
  @Prop() multiselectable!: boolean;
  @Prop({ default: false }) selectable!: boolean;
  @Prop() documents: [];
  @Prop({ default: false }) loading: boolean;

  private selectedDocumentIndex = ' 0';
  mounted() {
    this.selectedDocumentIndex = '0';
  }

  get columnsSize() {
    return this.fullViewMode ? '3' : '4';
  }

  async getSelectedDocuments() {
    return this.documents.filter(({ checked }) => checked);
  }

  async getSelectedDocument() {
    return this.documents[+this.selectedDocumentIndex];
  }

  documentDescription(desc: string): string {
    if (!isNaN(Number(desc))){
      let descFormatted = ''
      UploadDocumentTypes.forEach(group => {
        group.documents.forEach(doc => {
          if (doc.value === desc) descFormatted = doc.name
        })
      })
      if (!descFormatted) return desc
      return descFormatted.charAt(0).toUpperCase() + descFormatted.slice(1)
    }
    return desc
  }

  @Emit()
  selectDocument() {
    return this.documents.filter(({ checked }) => checked);
  }

  @Emit()
  remove(document: object) {
    return document;
  }

  @Emit()
  edit(document: object) {
    return document;
  }
}
